import React from 'react'

import {
  resolveSpacingTokens,
  UI2SpacingConfigProps as UI2SpacingProps,
} from 'shared-libs/components/ui2/layout/ui2-spacing.config'

/**
 * DW/MW half of the semantic spacing contract.
 *
 * The shared resolver decides which edge gets which token; this turns that
 * into an inline style. The concrete lengths stay in SCSS — the element
 * carries the `--ui2-spacing-*` custom properties via the `ui2-spacing-scale`
 * mixin, so this only ever emits a `var()` reference. Any component using
 * this MUST `@include ui2-spacing-scale` on the same element, or every
 * padding resolves to nothing.
 *
 * Returns undefined when the author set no spacing props, so callers can
 * spread it without emitting an empty style object.
 */
export function resolveUI2SpacingStyle(props: UI2SpacingProps): React.CSSProperties | undefined {
  const tokens = resolveSpacingTokens(props)
  if (!tokens) return undefined
  const style: React.CSSProperties = {}
  if (tokens.top) style.paddingTop = `var(--ui2-spacing-${tokens.top})`
  if (tokens.bottom) style.paddingBottom = `var(--ui2-spacing-${tokens.bottom})`
  if (tokens.left) style.paddingLeft = `var(--ui2-spacing-${tokens.left})`
  if (tokens.right) style.paddingRight = `var(--ui2-spacing-${tokens.right})`
  return style
}
